import { flow, makeObservable, observable } from 'mobx';
import RootStore from '.';
import BaseStore from './BaseStore';
import { LibraryApi, SettingApi } from '@/apis';
import { ResponseData } from '@/types/http';
import { SETTING_TIME_AUTO_DELETE_ITEM } from '@/configs/constants';
import { TableState } from '@tanstack/react-table';

export default class LibraryStore extends BaseStore {
    allFile: any[] = [];
    totalPage: number = 0;
    api: LibraryApi;

    constructor(rootStore: RootStore) {
        super(rootStore);
        makeObservable(this, {
            allFile: observable,
            totalPage: observable,
            getAllFile: flow.bound,
            deleteFile: flow.bound,
            uploadFile: flow.bound
        });
        this.api = new LibraryApi();
    }

    *getAllFile(paging?: TableState) {
        try {
            const payload = { ...this.convertPagingFromTableToRequest(paging ?? this.paging) };
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.getAllFile, payload);
            if (res.ok) {
                this.allFile = res.data.elements;
                this.paging = {
                    ...this.paging,
                    sorting: paging?.sorting ?? [],
                    pagination: this.convertPaginationFromRequestToTable(res.data.paginate)
                };
                this.totalRecord = res.data.paginate.totalRecord;
                this.totalPage = res.data.paginate.totalPage;
            }
            return res;
        } catch (error) {
        }
    }

    *deleteFile(id) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.deleteFile, id);
            if (res.ok) {
                return res;
            }
        } catch (error: any) {
            return error?.data;
        }
    }

    *uploadFile(payload) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.uploadFile, payload);
            if (res.ok) {
                return true;
            }
        } catch (error) {
        }
    }

    clean(): void {
        super.clean();
        this.allFile = [];
    }
}
